const MAIN_COLOR = "#00695c";
const LIGHT_COLOR = "#33877c";
const DARK_COLOR = "#004940";
const CONTRAST_COLOR = "#fff";

const FRIEND_REQUEST_BG = "rgba(230,230,240, 1)";
const MODAL_BUYING_BG = "#F5F5F5";
const GOLD_COLOR = "#bd8b28";
const MY_COLOR = MAIN_COLOR;
const CARD_MODAL_IMAGE_BG = "#222";
const MODAL_TITLE_COLOR = "white";
const MODAL_SCORES_BG = "#121212";

export {
  MAIN_COLOR,
  DARK_COLOR,
  LIGHT_COLOR,
  CONTRAST_COLOR,
  FRIEND_REQUEST_BG,
  MODAL_BUYING_BG,
  GOLD_COLOR,
  MY_COLOR,
  MODAL_TITLE_COLOR,
  CARD_MODAL_IMAGE_BG,
  MODAL_SCORES_BG
};
